import { Component, h } from 'preact';
import cx from 'classnames';

interface InquiryGridHeaderRowProps {
  stageSlug: string;
}

export class InquiryGridHeaderRow extends Component<InquiryGridHeaderRowProps> {
  render(props: InquiryGridHeaderRowProps) {
    return (
      <div className={ cx('hi-inqcard hi-inqcard-header-row', {
        'hi-inqcard--for-collection': props.stageSlug === 'for-collection'
      }) }>
        { props.stageSlug !== 'for-collection' && (
          <div className="hi-inqcard__date hi-inqcard__header-cell">
            <span>Inquiry Date</span>
          </div>
        )}
        <div className="hi-inqcard__name-group hi-inqcard__header-cell">
          <span>Inquirer</span>
        </div>

        {
          props.stageSlug === 'for-collection' &&
            <div className="hi-inqcard__collection-amount-group hi-inqcard__header-cell">
              <span>Total Contract Amount</span>
            </div>
        }

        {
          props.stageSlug === 'for-collection' &&
            <div className="hi-inqcard__collection-amount-group hi-inqcard__header-cell">
              <span>Hoppler Commission Amount</span>
            </div>
        }

        {
          props.stageSlug === 'for-collection' &&
            <div className="hi-inqcard__collection-amount-group hi-inqcard__header-cell">
              <span>Broker Commission Amount</span>
            </div>
        }

        { props.stageSlug === 'for-collection' && (
          <div className="hi-inqcard__invoice-number-group hi-inqcard__header-cell">
              <span>Invoice No.</span>
          </div>
        )}

        <div className="hi-inqcard__contact-group hi-inqcard__header-cell">
          <span>Contact Details</span>
        </div>
        <div className="hi-inqcard__movein-group hi-inqcard__header-cell">
          <span>Move-in Date</span>
        </div>
        <div className="hi-inqcard__details-group hi-inqcard__header-cell">
          <span>Inquiry Details</span>
        </div>
        <div className="hi-inqcard__attachments-group hi-inqcard__header-cell">
          <span>Comments/Attachments</span>
        </div>
        { props.stageSlug !== 'search' &&
            <div className="hi-inqcard__actions-group hi-inqcard__header-cell">
              <span>Actions</span>
            </div>
        }
        { props.stageSlug === 'search' && 
            <div className="hi-inqcard__stage-name-group hi-inqcard__header-cell">
              <span>Stage</span>
            </div>
        }

        {
          props.stageSlug === 'for-collection' &&
            <div className="hi-inqcard__collected-btn-group hi-inqcard__header-cell">
              <span>Collection Status</span>
            </div>
        }
      </div>
    )
  }
}
